import React, { useState } from "react"
import { GatsbyImage, getImage } from "gatsby-plugin-image"
import { Link } from "gatsby"
import { Col, Container, Row } from "react-bootstrap"

const PostsList = ({ data }) => {
  const articles = data.nodes
  const postsPerPage = 12
  const [currentPage, setCurrentPage] = useState(1)

  // Calculate total pages
  const totalPages = Math.ceil(articles.length / postsPerPage)

  const startIndex = (currentPage - 1) * postsPerPage
  const currentArticles = articles.slice(startIndex, startIndex + postsPerPage)

  // Handle page navigation
  const handlePageChange = pageNumber => {
    setCurrentPage(pageNumber)
  }

  // Pagination rendering logic
  const renderPagination = () => {
    const pages = [];

    // Always show the first page
    pages.push(
      <a
        key={1}
        href="#newsSection"
        className={`page-numbers mx-2 text-decoration-none ${
          currentPage === 1 ? "current" : ""
        }`}
        onClick={() => handlePageChange(1)}
      >
        1
      </a>
    );

    if (currentPage > 3) {
      // Add ellipsis if the current page is beyond 3
      pages.push(
        <span key="start-dots" className="page-numbers dots">
        …
      </span>
      );
    }

    // Show the range around the current page
    const rangeStart = Math.max(2, currentPage - 1);
    const rangeEnd = Math.min(totalPages - 1, currentPage + 1);

    for (let i = rangeStart; i <= rangeEnd; i++) {
      pages.push(
        <a
          key={i}
          href="#newsSection"
          className={`page-numbers mx-1 text-decoration-none ${
            currentPage === i ? "current" : ""
          }`}
          onClick={() => handlePageChange(i)}
        >
          {i}
        </a>
      );
    }

    if (currentPage < totalPages - 2) {
      // Add ellipsis if current page is far from the last page
      pages.push(
        <span key="end-dots" className="page-numbers dots">
        …
      </span>
      );
    }

    // Always show the last page
    if (totalPages > 1) {
      pages.push(
        <a
          key={totalPages}
          href="#newsSection"
          className={`page-numbers mx-1 text-decoration-none ${
            currentPage === totalPages ? "current" : ""
          }`}
          onClick={() => handlePageChange(totalPages)}
        >
          {totalPages}
        </a>
      );
    }

    return pages;
  };


  return (
    <div className="news-section" id="newsSection">
      <div className="ver-line"></div>
      <div className="ver-line ver-line-02"></div>
      <div className="ver-line ver-line-03"></div>
      <Container>
        <Row>
          {currentArticles?.map(article => (
            <Col key={article.slug} md={4} className="nws-col-1 news-col">
              <div className="news-box">
                <div className="news-thumb">
                  {article.featuredImage?.node?.localFile && (
                    <GatsbyImage
                      image={getImage(article?.featuredImage?.node?.localFile)}
                      alt={article.title}
                    />
                  )}
                </div>
                <div className="news-desc">
                  <div>
                    <span className="news-category-title">
                      <span>in</span>{" "}
                      {article.categories?.nodes?.map((category, index) => (
                        <span key={category.slug}>
                          <Link
                            to={category.uri}
                            className="text-decoration-none font-bold"
                          >
                            {category.name}
                          </Link>
                          {index < article.categories.nodes.length - 1 && ", "}
                        </span>
                      ))}
                    </span>
                    <div className="news-link">
                      <p>
                        <Link to={article.uri} className="text-decoration-none">
                          {article.title}
                        </Link>
                      </p>
                    </div>
                    <div className="news-date-sec">
                      <span className="month-name">By</span>{" "}
                      <span className="news-author">
                        {article.author?.node?.name || "Unknown"}
                      </span>{" "}
                      <span className="month-name">{article.date}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Col>
          ))}
        </Row>

        {/* Pagination */}
        <Row>
          <Col md={12}>
            <nav>
              <div className="nav-links text-center pagination">
                {renderPagination()}
              </div>
            </nav>
          </Col>
        </Row>
      </Container>
    </div>
  )
}

export default PostsList
